import React from "react";

const CollapseHeader = (props) => {
  return <div>{props.children}</div>;
};

export default CollapseHeader;
